import React from "react";
import PropTypes from "prop-types";
import { HighlightProvider } from "@learningblocks/shared-components";
import cName from "./style.module.scss";
import { PlainText } from "@learningblocks/simulations/shared-components";
import { FormattedMessage } from "react-intl";

/**
 * Question
 *    -Component accepts the HTML question text and render it to HTML
 */

export function Question(props) {
  const { onPlainTextClick } = React.useContext(HighlightProvider.Context);

  const onClickHighlight = (contentId, event) => {
    onPlainTextClick(contentId, event);
  };

  if (typeof props.text === "string") {
    return (
      <p className={`${cName.question} ${props.className}`} dir="auto">
        <FormattedMessage id={props.text} defaultMessage={props.text} />
      </p>
    );
  }
  if (typeof props.text === "object") {
    return (
      <PlainText
        className={`${cName.question} ${props.className}`}
        onClickHighlight={onClickHighlight}
        {...props.text}
      />
    );
  }
}

Question.propTypes = {
  /**
   * Text to be  displayed as question
   * Expects a string p tag
   */
  text: PropTypes.string.isRequired,
  /**
   * ClassName to set on the tag
   */
  className: PropTypes.string,
};

Question.defaultProps = {
  text: "",
  className: "",
};
